import React from "react";
import { Trans } from "react-i18next";

const CTRGeneral = ({ metricValue }) => {
  return (
    <>
      {metricValue > 1 ? (
        <Trans i18nKey={"ctr.greatNews"}>
          Wow! Your CTR is <b>{{ metricValue }}%</b>! 🌟 You're smashing it! Keep up the fantastic
          work!
        </Trans>
      ) : (
        <Trans i18nKey={"ctr.allGood"}>
          Congratulations on your <b>{{ metricValue }}%</b> CTR! 🚀 Aim for over 1% to reach even
          greater heights!
        </Trans>
      )}
    </>
  );
};

export default CTRGeneral;
